// 项目负责人,项目金额
export const defaultTableColumns = [
  {
    field: 'applyDate',
    title: '立项申请日期',
    width: '140',
  },
  {
    field: 'projectCode',
    title: '项目编号',
    width: '140',
  },
  {
    field: 'projectName',
    title: '项目名称',
    width: '140',
  },
  {
    field: 'projectStatus',
    title: '项目状态',
    width: '140',
  },
  {
    field: 'oaUrl',
    title: '审批详情',
  },
  {
    field: 'applyDepartmentName',
    title: '申请部门',
    width: '140',
  },

  {
    field: 'bidTitle',
    title: '投标抬头',
    width: '140',
  },
  {
    field: 'projectResponsiblePerson',
    title: '项目负责人',
    width: '140',
    //fixme
  },
  {
    field: 'bidderName',
    title: '业务人员',
    width: '140',
  },
  {
    field: 'projectSourceType',
    title: '项目来源',
    width: '140',
  },
  {
    field: 'bidTotalAmount',
    title: '项目金额',
    width: '140',
    //fixme
  },

  {
    field: 'bidOpeningDate',
    title: '开标日期',
    width: '140',
  },
  {
    field: 'bidClosingDate',
    title: '截标日期',
    width: '140',
  },
  // {
  //   field: 'productTypeName',
  //   title: '产品类型',
  //   width: '140',
  // },
  {
    field: 'serviceTypeName',
    title: '服务类型',
    width: '140',
  },
  {
    field: 'projectStartDate',
    title: '项目开始日期',
    width: '140',
  },
  {
    field: 'projectEndDate',
    title: '项目结束日期',
    width: '140',
  },
];
